import * as React from 'react';

import { observer } from 'mobx-react';

import { TextButton } from '@estee/elc-buttons';

import { IFormItem } from '~domain/entities/Config';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';
import { classes } from '~utils/Classes';
import { AccountSignInFormViewController } from '~views/account/AccountSignInFormViewController';

const forgotPasswordClassName = classes('iam-forgot-password-button');

const ForgotPassword = observer((props: IFormItem) => {
    const { inputLabel = '' } = props;
    const { forgotPasswordClicked } = diContainer.get(
        serviceNames.accountSignInFormViewController
    ) as AccountSignInFormViewController;

    return (
        <TextButton
            className={forgotPasswordClassName}
            disabled={false}
            onClick={forgotPasswordClicked}
        >
            {inputLabel}
        </TextButton>
    );
});

export default ForgotPassword;
